<div class="mt-2 grid grid-cols-1 gap-4 sm:grid-cols-3">
  @for (option of options; track option.inputId) {
    <div
      class="custom-radio flex"
      [ngClass]="{
        'items-center': inline,
        active: value === option.value
      }"
      (click)="onOptionSelected(option.value)"
    >
      <img
        *ngIf="value === option.value"
        src="assets/icons/check-circle-svgrepo-com.svg"
        alt="checkmark"
        class="h-4 w-4"
      />
      <label
        class="ml-2 text-sm font-normal leading-[1rem]"
        [ngClass]="{
          'text-white': value === option.value,
          'text-textPrimary': value !== option.value
        }"
      >
        {{ option.label }}
      </label>
    </div>
  }
</div>
